export default __webpack_public_path__ + "files/d760c2a16ebf36d76ba5f33b1a5966f7.png";